import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asHandoff, listResults } from "../lib/thirdDoorAdapters";

export default function MyFiles() {
    const { resources } = useModelIndex("handoff_event" as any, { limit: 50 } as any);
    const rows = listResults(resources).map(asHandoff);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("all");
    const filteredRows = useMemo(() => rows.filter((row) => {
      const matchesSearch = row.company.toLowerCase().includes(search.toLowerCase()) || row.capability.toLowerCase().includes(search.toLowerCase());
      const matchesStatus = status === "all" || row.status === status;
      return matchesSearch && matchesStatus;
    }), [search, status]);
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-4">
      <Card className="border-border shadow-sm">
      <CardContent className="grid gap-3 p-4 md:grid-cols-2">
      <Input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search by company or submission" />
      <Select value={status} onValueChange={setStatus}>
      <SelectTrigger><SelectValue placeholder="Filter status" /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="all">All statuses</SelectItem>
      <SelectItem value="New">New</SelectItem>
      <SelectItem value="In Progress">In Progress</SelectItem>
      <SelectItem value="Waiting">Waiting</SelectItem>
      <SelectItem value="Completed">Completed</SelectItem>
      </SelectContent>
      </Select>
      </CardContent>
      </Card>

      <Card className="border-border shadow-sm">
      <CardContent className="p-0">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Company</TableHead>
      <TableHead>Primary Capability</TableHead>
      <TableHead>Route</TableHead>
      <TableHead>Status</TableHead>
      <TableHead>Navigator Action</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {filteredRows.map((row) => (
      <TableRow key={row.company}>
      <TableCell className="font-medium">{row.company}</TableCell>
      <TableCell>{row.capability}</TableCell>
      <TableCell>{row.route}</TableCell>
      <TableCell><Badge variant="secondary">{row.status}</Badge></TableCell>
      <TableCell>
      <Button asChild size="sm" variant="outline">
      <Link to="/navigator-role/file-detail">Open file</Link>
      </Button>
      </TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}